import { connect } from 'react-redux';
import Breadcrumbs from '../../../shared/components/breadcrumbs';
import {deleteBreadcrumbTitleT, setBreadcrumbTitleT} from "../../../../state/actions/shared/breadcrumbs";

const BreadcrumbsRedux = (props) => (
  <Breadcrumbs
    entityType="companyCategories"
    {...props}
  />
);

const mapStateToProps = (state, ownProps) => {
  const { entityId } = ownProps;
  const pageEntities = state.companyCategories.editor;
  const currentPage = pageEntities[entityId]
  const { breadcrumb, breadcrumbTitle, title, updateId } = currentPage;
  return {
    breadcrumb,
    breadcrumbTitle,
    entityId,
    entityTitle: title,
    entityUpdateId: updateId,
  }
}

const mapDispatchToProps = (dispatch, ownProps) => {
  const {entityId:id} = ownProps;
  return {
    onDeleteBreadcrumbTitle: () => dispatch(deleteBreadcrumbTitleT('company_category', id)),
    onSetBreadcrumbTitle: (breadcrumbTitle) => dispatch(setBreadcrumbTitleT('company_category', breadcrumbTitle, id)),
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(BreadcrumbsRedux);
